import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { renderIf } from "MODULES/shared/decorators";
import {
  cancelCustomerRma,
  cancelVendorRma
} from "MODULES/RMAsAndWarranties/actions";
import {
  ActionDropDown,
  ConfirmAction,
  DropDownItem
} from "MODULES/shared/components";
import { CANCELLED, RECEIVED, TYPE } from "APP_ROOT/constants";
import { CREDIT_ISSUED } from "MODULES/RMAsAndWarranties/constants";
import PrintRma from "./PrintRma";
import withRma from "../../../decorators/withRma";
import RequestPartialCredit from "./RequestPartialCredit";

const VENDOR_PDF_TYPES = ["ber", "damage", "discrepancy", "insufficient_trace"];

class Actions extends React.Component {
  state = { cancelModalOpen: false };

  openModal = () => this.setState({ cancelModalOpen: true });
  closeModal = () => this.setState({ cancelModalOpen: false });

  render() {
    const { cancel, rma } = this.props;
    const { cancelModalOpen } = this.state;

    const displayCancel =
      !rma.get(CANCELLED) &&
      !rma.get("closed_date") &&
      !rma.get(RECEIVED) &&
      (rma.get(TYPE) !== "CustomerRma" || !rma.get(CREDIT_ISSUED));

    return (
      <React.Fragment>
        <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
          <ActionDropDown menuClass="dropdown-menu-right">
            {rma.get(TYPE) === "VendorRma" &&
              VENDOR_PDF_TYPES.map((t, index) => (
                <PrintRma key={`vendor-${index}`} pdfType={t} rma={rma} />
              ))}
            <RequestPartialCredit />
            {displayCancel && (
              <DropDownItem onClick={this.openModal}>
                <i className="fa fa-fw fa-ban" />
                &nbsp;Cancel RMA
              </DropDownItem>
            )}
          </ActionDropDown>
        </div>
        <ConfirmAction
          onConfirm={cancel}
          open={cancelModalOpen}
          close={this.closeModal}
          icon={<i className="fa fa-fw fa-check" />}
          btnText="Yes, Cancel RMA"
        >
          Are you sure you want to cancel this RMA?
        </ConfirmAction>
      </React.Fragment>
    );
  }
}

Actions.propTypes = {
  cancel: T.func.isRequired,
  rma: T.instanceOf(Map).isRequired
};

const connectedActions = connect(null, (dispatch, ownProps) => ({
  cancel: () => {
    const cancelAction =
      ownProps.rma.get(TYPE) === "VendorRma"
        ? cancelVendorRma
        : cancelCustomerRma;
    return dispatch(cancelAction());
  }
}))(Actions);

export default withRma(
  renderIf(({ rma }) => !rma.get(CANCELLED))(connectedActions)
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Actions/Actions.jsx